import { useCallback, useState } from 'react';

export default function useBoolean(initialValue: boolean = false) {
  const [value, setValue] = useState(initialValue);
  const toggle = useCallback(() => {
    setValue((prev) => !prev);
  }, []);
  const setTrue = useCallback(() => {
    setValue(true);
  }, []);
  const setFalse = useCallback(() => {
    setValue(false);
  }, []);

  return [value, { setValue, toggle, setTrue, setFalse }] as const;
}
